import axios from "axios";
import { GURL } from "./global";

export const GetMessageById = (id: any) => {
  const url = `${GURL}/Messaging/v1/TextMessage?Id=${id}`;
  //console.log(url);
  return axios.get(url);
};
